export default {
  name: "task"
};